import { translate } from '../../../Internationalization';
import Feature from '../../../../shared/Feature';
import flags from '../../../../shared/Flags';
import occupations from '@mooveguru/yhh-shared-config/users/agent/occupations.json';
import React from 'react';

/**
 * @param {{occupation: string}} props
 * @returns {JSX.Element}
 */
export default function AgentCardOccupation(props) {
	return (
		<Feature fallback={null} name={flags.group.showCobranding}>
			<p>
				{
					// @ts-ignore
					occupations[props.occupation] ??
						translate(
							`homeowner.pages.dashboard.agent.occupation.loan_officer`
						)
				}
			</p>
		</Feature>
	);
}
